export default __webpack_public_path__ + "static/media/lorry_dark.cb0350fc.png";